export const TypeDiscount = {
    Fix: 'fix',
    Percentage: 'percentage'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountReasons/IDiscount.ts
// module id = 48
// module chunks = 0